import { makeStyles } from '@material-ui/core/styles';
import EncodeSansLight from "../../../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf";
export default makeStyles(theme => ({
  modalMainMobile: {
    zIndex: "1000",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "5px 10px 18px #888888",
    padding:"10px",
    position: "fixed",
    background: "#fff",
    width: "80%",
    height: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
  },
  modalMainDesktop: {
    zIndex: "1000",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "5px 10px 18px #888888",
    padding:"10px",
    position: "fixed",
    background: "#fff",
    width: "500px",
    height: "auto",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
  },
  modalButtonConfirm: {
    borderRadius: "30px",
    color: "#fff",
    fontSize: "16px",
    background: "#BB0D66",
    padding: "4px 8px 4px 8px",
    marginLeft: "4px",
    marginRight: "4px",
    textDecoration:"none",
    border: "solid #BB0D66 0px",
    fontFamily: EncodeSansLight,
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  modalButtonModify: {
    borderRadius: "30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    padding: "4px 8px 4px 8px",
    marginLeft: "4px",
    marginRight: "4px",
    textDecoration:"none",
    border: "solid #BB0D66 0px",
    fontFamily: EncodeSansLight,
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
//END MODAL STYLES
  modalTitle: {
    fontFamily: "Poppins",
    fontWeight:600,
    fontSize: "20px",
    color:"#bb0d66",
    textAlign: "center"
  },
  modalColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems:"center",
    justifyContent: "space-evenly",
  },
  modalSubtitle: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "16px",
    textAlign:"center"
  },
  modalText2: {
    textAlign:"center",
    fontFamily: "Poppins",
    fontWeight: "200",
    letterSpacing:'-0.8',
    fontSize: "16px",
  },
  iconCircle: {
    clipPath: "circle(25px at 50% 50%)",
    background:"#bb0d66"
  },
  formBox: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding:"32px",
    width:"800px",
    boxShadow: "5px 10px 18px #888888",
  },
  formBoxMobile: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    width:"90%",
    padding:"32px",
    boxShadow: "5px 10px 18px #888888",
  },
  buttons: {
    display: 'flex',
    flexDirection:"row",
    justifyContent: 'center',
    fontSize: "18px",
    marginTop:"8px"
  },
  buttonContained: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#BB0D66",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  backButton: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));
